(function ($, Cobalt, undefined) {
    Cobalt.ExportImportSettings =
    {
        initialize: function () {
            $("#form-field-export-roles").hide();
            $("#form-field-export-structures").hide();

            $("#field-export-settings-role").on("change", function () {
                if ($(this).prop('checked')) {
                    $("#form-field-export-roles").show();
                    $("#form-field-export-roles li input").prop('checked', true);
                } else {
                    $("#form-field-export-roles").hide();
                }
            });


            $("#field-export-settings-pagestructure").on("change", function () {
                if ($(this).prop('checked')) {
                    $("#form-field-export-structures").show();
                    //$("#form-field-export-structures li input").prop('checked', true);
                } else {
                    $("#form-field-export-structures").hide();
                }
            });

            $("#form-field-export-advertising-content").hide();

            $("#field-export-settings-advertisingslot").on("change", function () {
                if ($(this).prop('checked')) {
                    $("#form-field-export-advertising-content").show();
                } else {
                    $("#form-field-export-advertising-content").hide();
                }
            });
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.ExportImportSettings.js